Date.prototype.ddmmyyyy = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    this.getFullYear(),
  ].join("/");
};

Date.prototype.isValidDate = function () {
  return !isNaN(this.getTime());
};

String.prototype.toDateObject = function (splitDate, _format, defaultValue) {
  try {
    if (!_format) {
      if (splitDate) {
        if (splitDate == "/") {
          let dateParam = this.split(/[\s/:]/);
          dateParam[1] = (parseInt(dateParam[1], 10) - 1).toString();
          return new Date(...dateParam);
        } else {
          if (splitDate == "-") {
            let dateParam = this.split(/[\s-:]/);
            dateParam[1] = (parseInt(dateParam[1], 10) - 1).toString();
            return new Date(...dateParam);
          }
        }
      }
      var pattern = /^\d+$/;
      if (pattern.test(this)) {
        // returns a boolean
        var number = new Number(this);
        return new Date(number);
      } else {
        return new Date(this);
      }
    } else {
      var formatLowerCase = _format.toLowerCase();
      var formatItems = formatLowerCase.split(splitDate);
      var dateItems = this.split(splitDate);
      var monthIndex = formatItems.indexOf("mm");
      var dayIndex = formatItems.indexOf("dd");
      var yearIndex = formatItems.indexOf("yyyy");
      if (
        monthIndex == -1 ||
        dayIndex == -1 ||
        yearIndex == -1 ||
        dateItems.length <= Math.max(monthIndex, dayIndex, yearIndex)
      ) {
        return new Date(this);
      }
      var month = parseInt(dateItems[monthIndex]);
      month -= 1;
      var formatedDate = new Date(
        dateItems[yearIndex],
        month,
        dateItems[dayIndex]
      );
      return formatedDate;
    }
  } catch (e) {
    return defaultValue || new Date();
  }
};

Number.prototype.toDateObject =
  String.prototype.toDateObject ||
  function () {
    try {
      return new Date(this);
    } catch (e) {
      return new Date();
    }
  };

Date.prototype.getHours12 = function () {
  var hours1 = this.getHours();
  var hours = hours1 % 12;
  hours = hours ? hours : hours1 >= 12 ? 12 : 0; // the hour '0' should be '12'
  return hours;
};

Date.prototype.format = function (pattent) {
  var thu = /thu/g;
  var dd = /dd/g;
  var MM = /MM/g;
  var yyyy = /yyyy/g;
  var YYYY = /YYYY/g;
  var M = /M/g;
  var yy = /yy/g;
  var YY = /YY/g;
  var HH = /HH/g;
  var hh = /hh/g;
  var mm = /mm/g;
  var ss = /ss/g;
  var tt = /tt/g;

  var date = (this.getDate() > 9 ? "" : "0") + this.getDate();
  pattent = pattent.replace(dd, date);
  var month = this.getMonth() + 1; // getMonth() is zero-based
  month = (month > 9 ? "" : "0") + month;
  pattent = pattent.replace(MM, month);
  pattent = pattent.replace(M, month);
  var year = this.getFullYear();
  pattent = pattent.replace(YYYY, year);
  pattent = pattent.replace(yyyy, year);
  var _year = (year + "").substring(2);
  pattent = pattent.replace(yy, _year);
  pattent = pattent.replace(YY, _year);

  var hour = this.getHours();
  var hour12 = this.getHours12();
  pattent = pattent.replace(hh, hour12);
  hour = (hour > 9 ? "" : "0") + hour;
  pattent = pattent.replace(HH, hour);

  var minute = this.getMinutes();
  minute = (minute > 9 ? "" : "0") + minute;
  pattent = pattent.replace(mm, minute);

  var second = this.getSeconds();
  second = (second > 9 ? "" : "0") + second;
  pattent = pattent.replace(ss, second);

  var _tt = this.getHours() > 12 ? "PM" : "AM";
  pattent = pattent.replace(tt, _tt);

  var dateInWeek = [
    "Chủ nhật",
    "Thứ 2",
    "Thứ 3",
    "Thứ 4",
    "Thứ 5",
    "Thứ 6",
    "Thứ 7",
  ];
  var day = this.getDay();
  pattent = pattent.replace(thu, dateInWeek[day]);

  return pattent;
};

Date.prototype.getAge = function () {
  var date = new Date();
  if (date.getFullYear() < this.getFullYear()) return 0;
  if (date.getFullYear() === this.getFullYear()) return 1;
  return date.getFullYear() - this.getFullYear();
};

Date.prototype.compareDate = function (date) {
  if (this.ddmmyyyy() == date.ddmmyyyy()) return 0;
  return this.getTime() > date.getTime() ? 1 : -1;
};
Number.prototype.compareDate = function (timeMilisecond) {
  var date1 = timeMilisecond.toDateObject();
  var date = this.toDateObject();

  if (date.ddmmyyyy() == date1.ddmmyyyy()) return 0;
  return this > timeMilisecond ? 1 : -1;
};

String.prototype.getPostTime =
  String.prototype.getPostTime ||
  function () {
    try {
      var date10Day = 86400 * 10;
      var dateOneDay = 86400;
      var dateOneHour = 3600;
      var dateOneMinute = 60;
      var dateDayName = " ngày trước";
      var dateHourName = " giờ trước";
      var dateMinuteName = " phút trước";
      var dateJustNowName = "Vừa xong";

      var _this = parseFloat(this + "");
      var time = "";
      var date = new Date();
      date.setTime(_this);
      var now = new Date().getTime();
      var totalTimeDiff = (now - _this) / 1000;
      if (totalTimeDiff > date10Day) {
        return date.format("dd-MM-yyyy HH:mm:ss");
      }
      if (totalTimeDiff > dateOneDay) {
        var day = parseInt(totalTimeDiff / dateOneDay + "");
        return day + dateDayName;
      }
      if (totalTimeDiff > dateOneHour) {
        var hour = parseInt(totalTimeDiff / dateOneHour + "");
        return hour + dateHourName;
      }
      if (totalTimeDiff > dateOneMinute) {
        var minute = parseInt(totalTimeDiff / dateOneMinute + "");
        return minute + dateMinuteName;
      } else return dateJustNowName;
    } catch (e) {
      return "";
    }
  };

Number.prototype.getPostTime =
  String.prototype.getPostTime ||
  function () {
    return (this + "").getPostTime();
  };

Date.prototype.getPostTime =
  Date.prototype.getPostTime ||
  function () {
    return this.getTime().getPostTime();
  };

Date.prototype.getFirstDateOfMonth =
  Date.prototype.getLastDateOfMonth ||
  function () {
    return (this.format("yyyy-MM-") + "01").toDateObject();
  };

Date.prototype.getLastDateOfMonth =
  Date.prototype.getLastDateOfMonth ||
  function () {
    for (let i = 31; i > 0; i--) {
      try {
        let date = (
          this.format("yyyy-MM-") +
          (i < 10 ? "0" : "") +
          i
        ).toDateObject();
        if (date.isValidDate() && date.getDate() == i) return date;
      } catch (error) {}
    }
    return this;
  };

/*


*/
String.prototype.completeDate =
  String.prototype.completeDate ||
  function (max_Date, min_Date) {
    let text = this;
    return new Promise((resolve, reject) => {
      try {
        if (!text) {
          reject({
            code: 1,
            message: "Không được truyền rỗng",
          });
          return;
        }
        text = text.trim();
        if (text.length > 10) {
          reject({
            code: 2,
            message: "Vui lòng nhập đúng định dạng ngày tháng",
          });
          return;
        }
        var _date = text.toDateObject();
        var year = new Date().getFullYear();
        var date = "";
        if (text.length === 4) {
          date = "01/01/" + text;
        } else if (text.length === 5) {
          date = text[3] + text[4] + "/" + text[0] + text[1] + "/" + year;
        } else if (text.length === 6) {
          var year = new Date().getFullYear();

          if (
            parseInt(year.toString().substr(-2)) < parseInt(text[4] + text[5])
          ) {
            date =
              text[2] +
              text[3] +
              "/" +
              text[0] +
              text[1] +
              "/" +
              (parseInt(year.toString().substr(0, 2)) - 1) +
              text[4] +
              text[5];
          } else {
            date =
              text[2] +
              text[3] +
              "/" +
              text[0] +
              text[1] +
              "/" +
              year.toString().substr(0, 2) +
              text[4] +
              text[5];
          }
        } else if (text.length === 8) {
          if (text.indexOf("/") != -1) {
            return this.fixBOD2(text.replace(/\//g, ""), max_Date, min_Date);
          } else {
            date =
              text[2] +
              text[3] +
              "/" +
              text[0] +
              text[1] +
              "/" +
              text[4] +
              text[5] +
              text[6] +
              text[7];
          }
        } else if (text.length === 10) {
          date =
            text[3] +
            text[4] +
            "/" +
            text[0] +
            text[1] +
            "/" +
            text[6] +
            text[7] +
            text[8] +
            text[9];
        } else if (text.length === 7) {
          date = "";
        } else {
          var temp = text.split("/");
          date =
            temp[1][0] +
            temp[1][1] +
            "/" +
            temp[0][0] +
            temp[0][1] +
            "/" +
            temp[2][0] +
            temp[2][1] +
            temp[2][2] +
            temp[2][3];
        }

        var _date = date.toDateObject();
        if (!_date.isValidDate()) {
          reject({
            code: 2,
            message: "Vui lòng nhập đúng định dạng ngày tháng",
          });
        } else {
          if (min_Date != undefined && _date < min_Date) {
            reject({
              date: min_Date,
              code: 3,
              message:
                "Vui lòng nhập ngày lớn hơn " + min_Date.format("dd/MM/yyyy"),
            });
            return;
          }
          if (max_Date != undefined && _date > max_Date) {
            reject({
              date: max_Date,
              code: 4,
              message:
                "Vui lòng nhập ngày nhỏ hơn " + max_Date.format("dd/MM/yyyy"),
            });
            return;
          }
          resolve(_date);
        }
      } catch (e) {
        console.log(e);
        reject({
          code: 2,
          message: "Vui lòng nhập đúng định dạng ngày tháng",
        });
        return;
      }
    });
  };

module.exports = {};
